import * as React from 'react';
import {memo} from 'react';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import EllipsisSvg from "../../icons/Ellipsis";

const ButtonWitchMenu = (props) => {

    const {
        handleDetail = () => {},
        handleRoute = () => {},
        handleExcel = () => {},
        rangeNamer
    } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDetailOnClick = () => {
        handleDetail()
        handleClose()
    }
    const handleRouteOnClick = () => {
        handleRoute()
        handleClose()
    }
    const handleExcelOnClick = () => {
        handleExcel()
        handleClose()
    }

    return (
        <div>
            <Button
                sx={{minWidth: "16px"}}
                id="demo-positioned-button"
                aria-controls={open ? 'demo-positioned-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <EllipsisSvg />
            </Button>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <MenuItem className={'drop-menu-option'} onClick={handleDetailOnClick}>Детализация</MenuItem>
                <MenuItem className={'drop-menu-option'} onClick={handleRouteOnClick}>Показать маршрут {rangeNamer}</MenuItem>
                <MenuItem className={'drop-menu-option'} onClick={handleExcelOnClick}>Скачать Excel {rangeNamer}</MenuItem>
                {/* <MenuItem onClick={handleClose}>My account</MenuItem> */}
                {/* <MenuItem onClick={handleClose}>Logout</MenuItem> */}
            </Menu>
        </div>
    );
}

export default memo(ButtonWitchMenu)